import {
	Dialog,
	DialogTitle,
	Typography,
	DialogContent,
	DialogProps,
	DialogTitleProps,
	DialogContentProps,
	IconButton,
	useMediaQuery,
} from "@mui/material";
import { Controller, UseControllerOptions } from "react-hook-form";

import OTPFields, { OTPFieldsProps } from "auth/admin/OTPFields";

import { ReactComponent as ArrowLeft } from "assets/svg/arrow-left.svg";

interface PINDialogProps extends DialogProps {
	dialogTitleProps?: DialogTitleProps;
	dialogContentProps?: DialogContentProps;
	controllerProps: UseControllerOptions;
	otpFieldsProps: Omit<OTPFieldsProps, "value" | "onChange">;
	useRemUnit?: boolean;
	title: string;
	onCancel?: () => void;
}

export const PINDialog = ({
	dialogTitleProps,
	dialogContentProps,
	controllerProps,
	otpFieldsProps,
	useRemUnit = false,
	title,
	onCancel,
	children,
	...props
}: PINDialogProps) => {
	const matchesMobile = useMediaQuery("(max-width:34em)");

	return (
		<Dialog
			PaperProps={{
				sx: {
					width: useRemUnit ? "73rem" : "730px",
					height: useRemUnit ? "30rem" : "300px",
					borderRadius: useRemUnit ? "0.8rem" : "8px",
					...(matchesMobile
						? {
								m: 0,
								maxWidth: "none",
								maxHeight: "none",
								width: "100%",
								height: "100svh",
								borderRadius: 0,
						  }
						: {}),
				},
			}}
			{...props}
		>
			<DialogContent
				sx={{
					display: "flex",
					flexDirection: "column",
					justifyContent: matchesMobile ? "flex-start" : "center",

					p: useRemUnit ? "2rem" : "20px",

					"& input": {
						width: `${useRemUnit ? "6rem" : "60px"} !important`,
						height: `${useRemUnit ? "7rem" : "70px"} !important`,
						flex: "0 1 auto !important",
						fontSize: `${useRemUnit ? "3.6rem" : "36px"} !important`,
						fontWeight: "500 !important",
					},
					...(matchesMobile
						? {
								"& .MuiStack-root": {
									mt: useRemUnit ? "3.2rem" : "32px",
								},
						  }
						: {}),
				}}
				{...dialogContentProps}
			>
				<DialogTitle
					sx={{
						position: "relative",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						gap: useRemUnit ? "1.6rem" : "16px",

						p: useRemUnit ? "2rem" : "20px",
					}}
					{...dialogTitleProps}
				>
					{matchesMobile && (
						<IconButton
							sx={{
								position: "absolute",
								top: "50%",
								left: 0,
								transform: "translateY(-50%)",
								width: "32px",
								height: "32px",
							}}
							onClick={onCancel}
						>
							<ArrowLeft />
						</IconButton>
					)}
					<Typography
						component="span"
						fontWeight={800}
						fontSize={matchesMobile ? "16px" : useRemUnit ? "2.2rem" : "22px"}
						color="grey.600"
					>
						{title}
					</Typography>
				</DialogTitle>
				<Controller {...controllerProps} render={(field) => <OTPFields {...field} {...otpFieldsProps} />} />
			</DialogContent>
		</Dialog>
	);
};
